import { getIsMobile, getIsTablet } from '@bridebook/web/app-basic/lib/app/selectors';
import { getSupplier } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { A, Button } from '@bridebook/ui';
import DescriptionShortComp, {
  IProps as IDescriptionShortCompProps,
} from '@bridebook/web/app-basic/components/supplier/sections/description-short/description-short';

const DescriptionShort = () => {
  const { t } = useTranslation('supplier');
  const supplier = useSelector(getSupplier);
  const isMobile = useSelector(getIsMobile);
  const isTablet = useSelector(getIsTablet);

  if (!supplier) return null;

  const button = (
    <A href="#supplier-description-full">
      <Button theme="ghost" text={t('button.readMore')} />
    </A>
  );

  const props: IDescriptionShortCompProps = {
    isMobile,
    isTablet,
    button,
    supplier,
  };

  return <DescriptionShortComp {...props} />;
};

export default DescriptionShort;
